/**
 * Знакомство с приложением.
 *
 * Приложение строит день не так, как остальные планировщики: вокруг сна и еды,
 * а не вокруг списка дел. Человек, пришедший из списка дел, этого не видит —
 * он ищет кнопку «добавить задачу», находит календарь, пожимает плечами и
 * уходит. Несколько экранов в начале стоят дешевле, чем потерянный человек.
 *
 * Правила знакомства простые, и они же его и оправдывают: показывается один
 * раз, пропускается одной кнопкой, ничего не заставляет заполнять. Знакомство,
 * из которого нельзя выйти, читают по диагонали и закрывают с раздражением —
 * а это первое, что человек узнаёт о приложении.
 */

import { updateProfile } from '@/entities/profile/model/use-profile';
import { isDemoEmail } from '@/features/auth/model/demo-account';
import type { Profile } from '@/shared/db/schema';

/**
 * Показывать ли знакомство.
 *
 * Демо смотрят, чтобы увидеть приложение наполненным, — там всё на месте и
 * рассказывать не о чем. Пока профиль не прочитан, не показываем ничего:
 * мелькнувшее и исчезнувшее окно хуже, чем его отсутствие.
 */
export function shouldShowOnboarding(
  profile: Profile | null | undefined,
  email: string | null | undefined,
): boolean {
  if (!profile) return false;
  if (email && isDemoEmail(email)) return false;

  return profile.onboardingCompletedAt === null;
}

/** Знакомство пройдено или пропущено — второй раз само не появится. */
export async function completeOnboarding(profile: Profile): Promise<void> {
  if (profile.onboardingCompletedAt !== null) return;

  await updateProfile(profile.id, { onboardingCompletedAt: Date.now() });
}
